import React, { useRef } from "react";
import { Box } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer/Footer";
import { Typography, Divider } from "@mui/material";

import CompactProjectCard from "./project";
import ProjectKrishi2 from "./ProjectKrishi2";
import ProjectCard from "./ProjectCard";

const ProjectPage = () => {
  const contactUsRef = useRef(null);
  const handleContactUsClick = () => {
    window.open("https://wa.me/919353511090", "_blank");
    if (contactUsRef.current) {
      contactUsRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        background: `linear-gradient(90deg, rgba(209,230,226,1) 0%, rgba(234,238,236,1) 95%)`,
      }}
    >
      <Navbar onContactUsClick={handleContactUsClick} />

      <ProjectCard />

      <Footer />
    </Box>
  );
};

export default ProjectPage;
